export default {
  required: '{_field_} مطلوب',
  email: 'الرجاء إدخال عنوان بريد إلكتروني صحيح',
  phone: 'الرجاء إدخال رقم هاتف صحيح',
  numeric: '{_field_} يجب أن يكون رقم',
  confirmed: 'كلمة المرور غير متطابقة',
  min: '{_field_} يجب أن يحتوي على  {length} رقم على الأقل',
  max: '{_field_} يجب أن يحتوي على {length} رقم على الأكثر',
};